<template>
  <b-container>
    <b-row >
        <b-col tag="section" cols="12">
          <content-loader class="d-none d-lg-block"
            :width="600"
            :height="725"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
          >
            <rect x="28" y="24" rx="0" ry="0" width="0" height="1" />
            <rect x="62" y="19" rx="0" ry="0" width="1" height="1" />
            <rect x="2" y="8" rx="0" ry="0" width="105" height="33" />
            <rect x="119" y="8" rx="0" ry="0" width="105" height="33" />
            <rect x="237" y="8" rx="0" ry="0" width="107" height="33" />
            <rect x="2" y="91" rx="0" ry="0" width="80" height="16" />
            <rect x="-1" y="125" rx="0" ry="0" width="156" height="94" />
            <rect x="169" y="126" rx="0" ry="0" width="41" height="6" />
            <rect x="169" y="159" rx="0" ry="0" width="419" height="10" />
            <rect x="169" y="175" rx="0" ry="0" width="232" height="10" />
            <rect x="169" y="193" rx="0" ry="0" width="376" height="10" />
            <rect x="169" y="207" rx="0" ry="0" width="411" height="10" />
            <rect x="169" y="140" rx="0" ry="0" width="71" height="13" />
            <rect x="252" y="139" rx="0" ry="0" width="42" height="13" />
            <rect x="304" y="139" rx="0" ry="0" width="75" height="13" />
            <rect x="386" y="139" rx="0" ry="0" width="15" height="14" />
            <rect x="-1" y="250" rx="0" ry="0" width="156" height="94" />
            <rect x="169" y="251" rx="0" ry="0" width="41" height="6" />
            <rect x="169" y="284" rx="0" ry="0" width="419" height="10" />
            <rect x="169" y="300" rx="0" ry="0" width="232" height="10" />
            <rect x="169" y="318" rx="0" ry="0" width="376" height="10" />
            <rect x="169" y="332" rx="0" ry="0" width="411" height="10" />
            <rect x="169" y="265" rx="0" ry="0" width="71" height="13" />
            <rect x="252" y="264" rx="0" ry="0" width="42" height="13" />
            <rect x="304" y="264" rx="0" ry="0" width="75" height="13" />
            <rect x="2" y="374" rx="0" ry="0" width="156" height="94" />
            <rect x="169" y="375" rx="0" ry="0" width="41" height="6" />
            <rect x="169" y="408" rx="0" ry="0" width="419" height="10" />
            <rect x="169" y="424" rx="0" ry="0" width="232" height="10" />
            <rect x="169" y="442" rx="0" ry="0" width="376" height="10" />
            <rect x="169" y="456" rx="0" ry="0" width="411" height="10" />
            <rect x="169" y="389" rx="0" ry="0" width="71" height="13" />
          </content-loader>

          <content-loader class="d-lg-none"
          :height="1100"
          :width="510"
          :speed="2"
          primaryColor="#f3f3f3"
          secondaryColor="#dedede"
        >
          <rect x="0" y="45" rx="4" ry="4" width="300" height="30" />
          <rect x="0" y="100" rx="4" ry="4" width="510" height="200" />
          <rect x="0" y="330" rx="4" ry="4" width="100" height="12" />
          <rect x="0" y="355" rx="4" ry="4" width="500" height="12" />
          <rect x="0" y="380" rx="4" ry="4" width="500" height="12" />
          <rect x="0" y="405" rx="4" ry="4" width="500" height="12" />

          <rect x="0" y="500" rx="4" ry="4" width="510" height="200" />
          <rect x="0" y="730" rx="4" ry="4" width="100" height="12" />
          <rect x="0" y="755" rx="4" ry="4" width="500" height="12" />
          <rect x="0" y="780" rx="4" ry="4" width="500" height="12" />
          <rect x="0" y="805" rx="4" ry="4" width="500" height="12" />
          </content-loader>
        </b-col>
    </b-row>
   </b-container>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  components: {
    ContentLoader
  }
}
</script>

<style>

</style>
